import { render, staticRenderFns } from "./e-chip-status-tooltip.vue?vue&type=template&id=38d5b50c&scoped=true&lang=pug"
import script from "./e-chip-status-tooltip.vue?vue&type=script&lang=js"
export * from "./e-chip-status-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5b50c",
  null
  
)

export default component.exports